export const ACCENT_COLORS = {
  red: 'border-l-red-400',
  orange: 'border-l-orange-400',
  amber: 'border-l-amber-400',
  yellow: 'border-l-yellow-400',
  lime: 'border-l-lime-400',
  green: 'border-l-green-400',
  emerald: 'border-l-emerald-400',
  teal: 'border-l-teal-400',
  cyan: 'border-l-cyan-400',
  sky: 'border-l-sky-400',
  blue: 'border-l-blue-400',
  indigo: 'border-l-indigo-400',
  violet: 'border-l-violet-400',
  purple: 'border-l-purple-400',
  fuchsia: 'border-l-fuchsia-400',
  pink: 'border-l-pink-400',
  rose: 'border-l-rose-400',
  gray: 'border-l-gray-400',
};

export const TIME_SLOT_HEIGHT = 56;
